export const POSITION_NAME = "positionName";
export const APPROVED_BUDGET = "approveBudgets";
export const IS_ACTIVE = "active";
export const IS_APPROVE_CONTRACT = "approveContract";
export const APPROVE_CONTRACT_AMOUNT_LIMIT = "approveContractAmtLimit";
export const IS_APPROVE_AP_INVOICE = "approveApInv";
export const APPROVE_AP_INVOICE_AMOUNT_LIMIT = "approveApInvAmtLimit";
export const APPROVE_AP_INVOICE_AMOUNT_YEARLY_LIMIT =
  "approveApInvAmtYearlyLimit";
export const IS_APPROVE_WORK_ORDER = "approveWorkOrders";
export const APPROVE_WORK_ORDER_AMOUNT_LIMIT = "approveWoAmtLimit";
export const IS_APPROVE_PENALTIES = "approvePenalties";
export const APPROVE_PENALTIES_AMOUNT_LIMIT = "approvePnltAmtLimit";
export const DESCRIPTION = "description";
export const APPROVAL = "approval";
